import LoadingButton from "@mui/lab/LoadingButton";
import { Grid } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useIsOfferFormDataValid } from "./useIsOfferFormDataValid";

export const SubmitButton = (props) => {
    const { t } = useTranslation();
    const { fields, onSubmit } = props;
    const { getValues } = useFormContext();

    const formValidResult = useIsOfferFormDataValid(fields);
    const { isValid: canSubmit } = formValidResult;

    return (
        <Grid container justifyContent={"center"} sx={{ mt: 2 }}>
            <Grid item xs={12}>
                <LoadingButton
                    variant="contained"
                    fullWidth
                    onClick={() => onSubmit(getValues())}
                    disabled={!canSubmit || props.isLoading}
                    loading={props.isLoading}
                >
                    {t("offers.DialogTabs.save")}
                </LoadingButton>
            </Grid>
        </Grid>
    );
};
